<template>
  <v-container fluid>
    <page-title icon="fas fa-fw fa-fax">
      Fax Snippets
      <template v-slot:buttons>
        <v-btn :to="{name: 'admin.fax_snippet.create'}"
               color="primary"
               class="mr-2">
          New Snippet
        </v-btn>
        <v-btn :to="{name: 'admin.fax_messages.index'}"
               class="mr-2">
          Fax Messages
        </v-btn>
        <v-btn :to="{name: 'admin.fax_contacts.index'}"
               class="mr-2">
          Fax Contacts
        </v-btn>
      </template>
    </page-title>

    <template v-if="busy">

    </template>
    <template v-else>
      <p v-if="snippets.length === 0"
         class="text-center">
        There are no fax snippets yet.<br/>
        <v-btn :to="{name: 'admin.fax_snippet.create'}">
          Add one now
        </v-btn>
      </p>
      <template v-for="snippet in snippets">
        <fax-snippet-card :snippet="snippet"
                          :key="snippet.id"
                          class="mb-4"
                          @deleted="fetchData">
        </fax-snippet-card>
      </template>
    </template>
  </v-container>
</template>
<script>
import {orderBy} from 'lodash';
import FaxSnippetCard from './components/FaxSnippetCard';
import faxService from '../../../../services/faxService';
import PageTitle from '../../../../components/PageTitle.vue';

export default {
  components: {PageTitle, FaxSnippetCard},
  data() {
    return {
      busy: false,
      snippets: [],
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (this.busy) {
        return;
      }
      this.busy = true;
      faxService.getFaxSnippets()
        .then(data => {
          this.snippets = orderBy(data, ['slug', 'created_at'], ['asc', 'asc']);
        })
        .finally(() => {
          this.busy = false;
        })
    },
  },
}
</script>
